const ConstantHelper = {
  CTACall: "tel:+971581765760",
  CTAChat:
    "https://api.whatsapp.com/send/?phone=+971581765760&text=*Hello+TZ+Creation+Team*,+I+have+some+queries,+regarding+project+/+service+/+pricing+such+as",

  RefundRequestWhatsppMessage:
    "https://api.whatsapp.com/send/?phone=+971581765760&text=*Hello+TZ+Creation+Team*,+I+want+to+raise+the+refund+request.",

  // Same WhatsApp number as CTAChat, with a custom prefilled message.
  getChatLink: (message) =>
    ConstantHelper.CTAChat.replace(
      /text=.*$/,
      `text=${encodeURIComponent(message)}`
    ),

  // Calendly page for the free 30-minute intro call.
  bookIntroCallUrl:
    "https://calendly.com/tzcreation/book-a-free-30-minute-intro-call",
  bookIntroCallLabel: "Book a free 30-minute intro call",

  shareOnPinterestUrl: "https://www.pinterest.com/pin/create/button/?url=",
  shareOnTwitterUrl: "https://twitter.com/intent/tweet?url=",
  shareOnFacebookUrl: "https://www.facebook.com/sharer/sharer.php?u=",
  shareOnLinkedinUrl:
    "https://www.linkedin.com/shareArticle?mini=true&url=",
  shareOnInstagramUrl: "https://www.instagram.com/tabrezdal/",
  copyLink: "https://www.instagram.com/tabrezdal/",

  TestimonialSectionTitle: "What our clients says",
  WriteReviewButton: "Write your review",
  goolgeReviewUrl: "https://g.page/r/CZlTyOiX99_wEAI/review",
};

export default ConstantHelper;
